import React from "react";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";
import FnrTypography from "FnrTypography";

const Title = () => {
  const { title } = useCategoryCardContext();

  return (
    <FnrTypography type="header" bold fontSize="lg" color="primary">
      {title}
    </FnrTypography>
  );
};

export default Title;
